import React from "react";
import { COLORS } from "utils/styles";

const StripeRestricted = () => (
  <div className="f7 w-100 lh-copy" style={{ color: COLORS.disclaimer }}>
    <sup>*</sup>Businesses which are listed as{" "}
    <a
      href="https://stripe.com/restricted-businesses"
      target="_blank"
      className="color-primary fw5 w-100"
      rel="noreferrer noopener"
    >
      restricted
    </a>{" "}
    by Stripe are not eligible to be sold via PriceBlocs. All Stripe accounts
    are subject to the Stripe Services Agreement and other legal requirements
    listed{" "}
    <a
      href="https://stripe.com/legal/"
      target="_blank"
      className="color-primary fw5 w-100"
      rel="noreferrer noopener"
    >
      here.
    </a>
  </div>
);

export default StripeRestricted;
